import { isLoggedInReducer as isLoggedIn } from '@app/store/reducers/is-logged-in.reducer';
import { userReducer as user } from '@app/store/reducers/user.reducer';
import { userAddressesReducer as userAddresses } from '@app/store/reducers/user-addresses.reducer';
import { airportsReducer as airports } from '@app/store/reducers/airports.reducer';
import { placesReducer as places } from '@app/store/reducers/places.reducer';
import { routerStateReducer as routerState } from '@app/store/reducers/router-state.reducer';
import { airlinesReducer as airlines } from '@app/store/reducers/airlines.reducer';
import { busCompaniesReducer as busCompanies } from '@app/store/reducers/bus-companies.reducer';
import { busTerminalsReducer as busTerminals } from '@app/store/reducers/bus-terminals.reducer';
import { toastrReducer as toastr } from '@app/store/reducers/toastr.reducer';
import { historyReducer as history } from '@app/store/reducers/history.reducer';
import { alertsReducer as alerts } from '@app/store/reducers/user-alerts.reducer';
import { isLoadingAlertListReducer as isLoadingAlertList } from '@app/store/reducers/is-loading-alert-list.reducer';
import { closeWebViewInDetailReducer as closeWebViewInDetail } from '@app/store/reducers/close-webview-in-detail.reducer';
import { trackingReducer as tracking } from '@app/store/reducers/tracking.reducer';
import { frequentFlyerProgramReducer as frequentFlyerProgram } from '@app/store/reducers/frequent-flyer.reducer';
import { provincesReducer as provinces } from '@app/store/reducers/provinces.reducer';
import { documentAssetsReducer as documentAssets } from '@app/store/reducers/document-assets.reducer';
import { seamlessLoginReducer as seamlessLoginToken } from '@app/store/reducers/seamless-login.reducer';
import {
  isAnInternationalSearchReducer as isAnInternationalSearch
} from '@app/store/reducers/is-an-international-search.reducer';
import {
  isTokenAuthenticateReducer as isTokenAuthenticate
} from '@app/store/reducers/is-token-authenticate.reducer';
import { setCloseWebviewModalReducer as setCloseWebviewModal } from '@app/store/reducers/close-webview-modal.reducer';
import { refreshSearchRootReducer as refreshSearch } from '@shared/refresh-search/store/reducers';
import { globalUiReducer as globalUi } from '@app/store/reducers/globalUi';
import { globalReducer as global } from '@app/store/reducers/global';
import { staticListsReducer as staticLists} from '@app/store/reducers/static-lists.reducer';

export const globalReducers = {
  globalUi,
  global,
  isAnInternationalSearch,
  isLoggedIn,
  isLoadingAlertList,
  closeWebViewInDetail,
  routerState,
  history,
  user,
  userAddresses,
  tracking,
  places,
  airports,
  airlines,
  busCompanies,
  busTerminals,
  toastr,
  alerts,
  frequentFlyerProgram,
  documentAssets,
  seamlessLoginToken,
  provinces,
  isTokenAuthenticate,
  setCloseWebviewModal,
  refreshSearch,
  staticLists
};
